/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars */

import { EVENTS } from '../../../app/constants/events';

xplenty.directive('modalPanel', [
  '$rootScope',
  '$timeout',
  '$compile',
  function ($rootScope, $timeout, $compile) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('../../../views/directives/modal-panel.html'),

      replace: true,

      link(scope, element) {
        element.appendTo(scope.$modalBody);

        const $body = element.find('.modal-panel-body');
        const $form = $compile(scope.itemObject.directive)(scope);

        $form.appendTo($body);

        scope.buttonText = scope.itemObject.saveButtonText;

        $timeout(function () {
          const modalBodyHeight = scope.$modalBody.height();

          element.css('top', 0); // modalBodyHeight
          $body.css('min-height', modalBodyHeight);
          $body.css('height', modalBodyHeight);

          element.addClass('animate');

          $timeout(function () {
            element.css({
              top: 0,
              'min-height': modalBodyHeight,
              height: modalBodyHeight,
            });
          }, 1000);
        }, 0);

        const close = function () {
          element.css({
            top: scope.$modalBody.height(),
          });
          $timeout(function () {
            $rootScope.$broadcast(EVENTS.MODAL_PANEL_CLOSED);
            element.remove();
            $form.remove();
          }, 500);
        };

        scope.closePanel = function () {
          close();
          $rootScope.$broadcast(EVENTS.MODAL_PANEL_CLOSE_CLICK);
        };

        scope.savePanel = function () {
          close();
          $rootScope.$broadcast(EVENTS.MODAL_PANEL_SAVE_CLICK);
        };

        scope.$on(EVENTS.MODAL_PANEL_CLOSE, function () {
          close();
        });

        scope.$on('$destroy', function () {
          element.remove();
          $form.remove();
        });
      },
    };
  },
]);
